<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" />
    <ald-modal
      name="loader"
      full-screen
      hide-close-button
      background-content="rgba(155, 155, 155, 0.8)"
    >
      <ald-loader :text="`${loaderText}...`" font="medium" text-color="rgba(0, 0, 0, 0.8)" />
    </ald-modal>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AldAutomotive',

  components: {},

  computed: {
    showLoader() {
      return this.$store.getters['ui/data']('loader');
    },

    loaderText() {
      return this.$store.getters['ui/data']('loaderText') || this.$t('message.generic.loadingData');
    }
  },

  watch: {
    showLoader(val) {
      if (val) {
        this.$modal.show('loader');
      } else {
        this.$modal.hide('loader');
      }
    }
  },

  mounted() {
    this.$cookiebot.consentBanner();
    this.setTheme(this.$store.getters['ui/data']('theme'));
    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  }
};
</script>
